module.exports = __webpack_public_path__ + "static/media/6A.eb87e332.jpg";